import React, { useState, useEffect } from 'react';
import * as api from '../../api';

const EmployeeAttendance = ({ employees }) => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');
  const [attendanceRecords, setAttendanceRecords] = useState([]);

  // Cargar asistencia desde base de datos
  useEffect(() => {
    loadAttendance();
  }, []);

  const loadAttendance = async () => {
    try {
      const res = await api.getAttendance();
      if (res.success) {
        setAttendanceRecords(res.data);
      } else {
        console.error(res.error);
      }
    } catch (error) {
      console.error("Error cargando asistencia:", error);
    }
  };

  const handleCheckIn = async () => {
    if (!selectedEmployeeId) {
      alert('Por favor, selecciona un empleado.');
      return;
    }

    try {
      const res = await api.registerAttendance({
        employee_id: selectedEmployeeId,
        type: "entrada"
      });

      if (res.success) {
        alert("Entrada registrada correctamente.");
        loadAttendance(); // Recargar tabla
      } else {
        alert(res.error || "Error al registrar entrada.");
      }

    } catch (error) {
      console.error(error);
      alert("Error de conexión.");
    }
  };

  const handleCheckOut = async () => {
    if (!selectedEmployeeId) {
      alert('Por favor, selecciona un empleado.');
      return;
    }

    try {
      const res = await api.registerAttendance({
        employee_id: selectedEmployeeId,
        type: "salida"
      });

      if (res.success) {
        alert("Salida registrada correctamente.");
        loadAttendance(); // Recargar tabla
      } else {
        alert(res.error || "Error al registrar salida.");
      }

    } catch (error) {
      console.error(error);
      alert("Error de conexión.");
    }
  };

  return (
    <div className="bg-[#F9EFD7] p-4 rounded-lg shadow mt-6">
      <h3 className="text-lg font-semibold text-[#3F1907] mb-3">
        Registro de Asistencia
      </h3>

      <div className="mb-4">
        <label className="block text-[#3F1907] text-sm font-bold mb-1">
          Seleccionar Empleado
        </label>
        <select
          value={selectedEmployeeId}
          onChange={(e) => setSelectedEmployeeId(e.target.value)}
          className="w-full px-3 py-2 border border-[#58735A] rounded-md focus:outline-none focus:ring-2 focus:ring-[#3F1907] bg-[#F9EFD7] text-[#3F1907]"
        >
          <option value="">Selecciona un empleado</option>
          {Array.isArray(employees) && employees.map(employee => (
            <option key={employee.id} value={employee.id}>
              {employee.name}
            </option>
          ))}
        </select>
      </div>

      <div className="flex space-x-4 mb-6">
        <button
          onClick={handleCheckIn}
          className="flex-grow bg-green-600 hover:bg-green-700 text-[#F9EFD7] font-bold py-2 px-4 rounded-md transition duration-200"
          disabled={!selectedEmployeeId}
        >
          Registrar Entrada
        </button>

        <button
          onClick={handleCheckOut}
          className="flex-grow bg-red-600 hover:bg-red-700 text-[#F9EFD7] font-bold py-2 px-4 rounded-md transition duration-200"
          disabled={!selectedEmployeeId}
        >
          Registrar Salida
        </button>
      </div>

      <h4 className="text-md font-semibold text-[#3F1907] mb-2">
        Historial de Asistencia
      </h4>

      {attendanceRecords.length === 0 ? (
        <p className="text-[#3F1907]">No hay registros de asistencia.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-[#58735A]">
            <thead className="bg-[#58735A]">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
                  Empleado
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
                  Entrada
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
                  Salida
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
                  Horas
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-[#F9EFD7] uppercase tracking-wider">
                  Fecha
                </th>
              </tr>
            </thead>

            <tbody className="bg-[#F9EFD7] divide-y divide-[#58735A]">
              {attendanceRecords.map(record => (
                <tr key={record.id}>
                  <td className="px-4 py-3 text-sm text-[#3F1907]">
                    {record.employee_name}
                  </td>
                  <td className="px-4 py-3 text-sm text-[#3F1907]">
                    {record.check_in 
                      ? new Date(record.check_in).toLocaleString() 
                      : '-'}
                  </td>
                  <td className="px-4 py-3 text-sm text-[#3F1907]">
                    {record.check_out 
                      ? new Date(record.check_out).toLocaleString() 
                      : '-'}
                  </td>
                  <td className="px-4 py-3 text-sm text-[#3F1907]">
                    {record.total_hours ?? '-'}
                  </td>
                  <td className="px-4 py-3 text-sm text-[#3F1907]">
                    {record.work_date}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default EmployeeAttendance;
